import React, { useState } from 'react';
import TermsOfService from './docs/TermsOfService';
import PrivacyPolicy from './docs/PrivacyPolicy';
import RefundPolicy from './docs/RefundPolicy';
import FAQ from './FAQ';

const Footer = () => {
  const [activeDoc, setActiveDoc] = useState(null); // Состояние для документов (terms, privacy, refund)
  const [showFAQ, setShowFAQ] = useState(false);     // Состояние для FAQ

  // Функция для закрытия модалки документов
  const closeModal = () => setActiveDoc(null);

  return (
    <footer style={{
      padding: '30px 20px',
      textAlign: 'center',
      background: '#0d0e12', // Темный фон в тон логотипу
      color: '#8a8d9a',
      borderTop: '1px solid #1f222e',
      fontFamily: 'sans-serif',
      position: 'relative'
    }}>
      <p style={{ margin: '0 0 10px 0', fontWeight: '600', color: '#fff' }}>© 2026 REALWORK. Все права защищены.</p>
      
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap', margin: '15px 0' }}>
        <button onClick={() => setShowFAQ(true)} style={{ ...linkStyle, color: '#a78bfa', fontWeight: '600' }}>
          Часто задаваемые вопросы (FAQ)
        </button>
        <button onClick={() => setActiveDoc('terms')} style={linkStyle}>Пользовательское соглашение</button>
        <button onClick={() => setActiveDoc('privacy')} style={linkStyle}>Политика конфиденциальности</button>
        <button onClick={() => setActiveDoc('refund')} style={linkStyle}>Условия возврата</button>
      </div>

      <p style={{ fontSize: '14px', margin: '10px 0 0 0' }}>
        Поддержка: <a href="mailto:realwork.support@gmail.com" style={{ color: '#9d4edd', textDecoration: 'none' }}>realwork.support@gmail.com</a>
      </p>

      {/* --- МОДАЛЬНЫЙ СЛОЙ ДЛЯ FAQ --- */}
      {showFAQ && (
        <div style={fullScreenModalStyle}>
          <FAQ onClose={() => setShowFAQ(false)} />
        </div>
      )}

      {/* --- МОДАЛЬНОЕ ОКНО ДЛЯ ДОКУМЕНТОВ --- */}
      {activeDoc && (
        <div style={modalOverlayStyle} onClick={closeModal}>
          <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <button onClick={closeModal} style={closeButtonStyle}>✕ Закрыть</button>
            <div style={{ marginTop: '20px', textAlign: 'left' }}>
              {activeDoc === 'terms' && <TermsOfService />}
              {activeDoc === 'privacy' && <PrivacyPolicy />}
              {activeDoc === 'refund' && <RefundPolicy />}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

// Стили
const linkStyle = {
  background: 'none',
  border: 'none',
  color: '#8a8d9a',
  cursor: 'pointer',
  fontSize: '14px',
  textDecoration: 'underline',
  padding: '0',
  transition: 'color 0.2s',
  outline: 'none',
};

const fullScreenModalStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#090d16',
  zIndex: 10000,
  overflowY: 'auto'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '12px',
  maxWidth: '850px',
  width: '90%',
  maxHeight: '85vh',
  overflowY: 'auto',
  position: 'relative',
  boxShadow: '0 5px 25px rgba(0,0,0,0.3)'
};

const closeButtonStyle = {
  position: 'absolute',
  top: '15px',
  right: '15px',
  background: '#e0e0e0',
  border: 'none',
  padding: '8px 12px',
  borderRadius: '6px',
  cursor: 'pointer',
  fontWeight: 'bold',
};

export default Footer;